import { observer } from 'mobx-react';
import * as React from 'react';
import { ReactNode } from 'react';

import { registerError } from '../../util/ErrorUtil';
import WarningNotice from '../invoice/notices/WarningNotice';

interface IErrorBoundaryProps {
  children?: React.ReactNode;
  errorTranslationKey: string;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

@observer
export default class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ hasError: true });
    console.error(error, errorInfo);
    registerError(error);
  }

  public render(): JSX.Element | ReactNode {
    if (this.state.hasError) {
      return <WarningNotice translationKey={this.props.errorTranslationKey} />;
    }
    return this.props.children;
  }
}
